import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IoHome } from 'react-icons/io5';
import { FiSearch } from 'react-icons/fi';
import { HiShoppingCart } from 'react-icons/hi';
import { FaUserCircle } from 'react-icons/fa';
import { IoIosNotifications } from 'react-icons/io';

import { motion } from 'framer-motion';

export default function Footer() {
  const [activity, setActivity] = useState('IoHome');
  const itemVariants = {
    tap: {
      scale: 0.5,
    },
  };
  const FooterIcons = [
    'IoHome',
    'FiSearch',
    'HiShoppingCart',
    'FaUserCircle',
    'IoIosNotifications',
  ];

  const filterIcon = (icon) => {
    switch (icon) {
      case 'IoHome':
        return (
          <Link to="/">
            <IoHome />
          </Link>
        );
      case 'FiSearch':
        return (
          <Link to="/">
            <FiSearch className="search-icon" />
          </Link>
        );
      case 'HiShoppingCart':
        return (
          <Link to="/">
            <HiShoppingCart />
          </Link>
        );
      case 'FaUserCircle':
        return (
          <Link to="/">
            <FaUserCircle />
          </Link>
        );
      case 'IoIosNotifications':
        return (
          <Link to="/">
            <IoIosNotifications />
          </Link>
        );
      default:
        return null;
    }
  };

  const renderFooterItem = () => {
    return FooterIcons.map((icon) => {
      if (activity === icon) {
        return (
          <motion.div
            key={icon}
            variants={itemVariants}
            whileTap="tap"
            className="footer__icon active"
            onClick={() => setActivity(`${icon}`)}
          >
            {filterIcon(icon)}
          </motion.div>
        );
      }
      return (
        <motion.div
          key={icon}
          variants={itemVariants}
          whileTap="tap"
          className="footer__icon "
          onClick={() => setActivity(`${icon}`)}
        >
          {filterIcon(icon)}
        </motion.div>
      );
    });
  };
  return <div className="footer">{renderFooterItem()}</div>;
}
